/**
 * ERPLoadingOverlay — full-screen blocking overlay.
 *
 * Renders when `ui-store.globalLoading === true`. Prevents all pointer
 * interaction while an async operation is in progress (save, status change, etc.).
 *
 * z-index 9000: above dialogs and drawers, below Sonner toasts (default ~9999999)
 * so error toasts are still visible over the overlay.
 *
 * Mount once in ERPLayout. Never mount inside feature modules.
 * Trigger via `useUIStore.setGlobalLoading(true, 'Saving…')`.
 */

import { useUIStore } from '@stores/ui-store';

import styles from './ERPLoadingOverlay.module.scss';

export function ERPLoadingOverlay() {
  const globalLoading = useUIStore((s) => s.globalLoading);
  const message = useUIStore((s) => s.globalLoadingMessage);

  if (!globalLoading) return null;

  return (
    <div
      className={styles.overlay}
      role="status"
      aria-live="polite"
      aria-label={message ?? 'Loading…'}
    >
      <div className={styles.panel}>
        <span className={styles.spinner} aria-hidden="true" />
        <span className={styles.message}>{message ?? 'Please wait…'}</span>
      </div>
    </div>
  );
}
